import { ProjectSaveParams } from './project-save-entry.component';
import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProjectSaveDialogService {
  public requests = new EventEmitter<ProjectSaveParams>();

  constructor() { }
  Show(params:ProjectSaveParams): void {
    this.requests.emit(params);
  }
}
